import { render, staticRenderFns } from "./LoginChoiceDialog.vue?vue&type=template&id=49199f13&scoped=true&"
import script from "./LoginChoiceDialog.vue?vue&type=script&lang=js&"
export * from "./LoginChoiceDialog.vue?vue&type=script&lang=js&"
import style0 from "./LoginChoiceDialog.vue?vue&type=style&index=0&id=49199f13&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49199f13",
  null
  
)

export default component.exports